module.exports = __webpack_public_path__ + "img/aghk-car-selected.ebc9ff6f.svg";